import ApiError from '@/features/api/error'
import { AxiosError } from 'axios'

export const isExpectedApiError = (
    error: unknown,
    expectedApiErrorIdentifiers: string[]
): error is ApiError & { status: number; identifier: string } => {
    return (
        error instanceof ApiError &&
        typeof error.status === 'number' &&
        typeof error.identifier === 'string' &&
        expectedApiErrorIdentifiers.includes(error.identifier)
    )
}

export const isNetworkConnectionError = (error: unknown): boolean =>
    error instanceof ApiError &&
    !!error.missingNetworkConnection &&
    error.previousError.code === AxiosError.ERR_NETWORK
